<div class="modal-content">
  <div class="modal-header">
    <h2 class="modal-title">{{ modalTitle }}</h2>
  </div>

  <form [formGroup]="formGroup">
    <div class="modal-body">
      <div class="field">
        <gains-select label="Project" placeholder="Select a project" formControlName="project" [items]="projectOptions" [required]="true"></gains-select>
      </div>
    </div>
  </form>

  <div class="modal-footer">
    <button class="footer-btns" nz-button nzType="default" (click)="onCancel()">Cancel</button>
    <button class="footer-btns" nz-button nzType="primary" [disabled]="!formGroup.valid || isLoadingProjects" (click)="onSave()">Move</button>
  </div>
</div>
